import { render, staticRenderFns } from "./SimpleDoubleDialog.vue?vue&type=template&id=4cb5b507&scoped=true&"
import script from "./SimpleDoubleDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleDoubleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDoubleDialog.vue?vue&type=style&index=0&id=4cb5b507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb5b507",
  null
  
)

export default component.exports